.fc-yearview {
  border-collapse: collapse !important;
  display: grid;
  table-layout: auto !important;
  width: 100% !important;
}
.fc-yearview thead,
.fc-yearview tbody,
.fc-yearview tr {
  display: contents;
}
.fc-yearview thead th,
.fc-yearview .fc-day-empty {
  grid-column: span 2;
}
.fc-yearview th {
  overflow: hidden;
  padding: 2px 4px;
}
.fc-yearview th.fc-day {
  border-right: none;
  font-weight: bold;
  padding: 2px 0;
  position: relative;
  text-align: center;
}
.fc-yearview .fc-day-empty {
  border: none;
}
.fc-yearview .fc-day-sat,
.fc-yearview .fc-day-sun {
  background-color: var(
    --fc-weekend-bg-color,
    var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3))
  );
}
.fc-yearview .fc-day-today {
  background-color: var(--fc-today-bg-color);
}
.fc-yearview .fc-events {
  border-left: none;
  padding: 1px 2px 0 2px;
  position: relative;
}
.fc-yearview .fc-events-bg {
  inset: 0;
  position: absolute;
  z-index: 1;
}
.fc-yearview .fc-events-fg {
  position: relative;
  z-index: 2;
}
.fc-yearview .fc-event.fc-bg-event {
  border: none;
  margin: 0;
}
.fc-yearview .fc-h-event {
  border-radius: 3px;
  font-size: var(--fc-small-font-size, 0.85em);
  margin: 1px 0 2px 0;
  overflow: hidden;
  padding: 1px 2px;
}
